module.exports = __webpack_public_path__ + "assets/img/btn-view-6a98b092.png";